// libraries
import styled from 'styled-components';

// js
import colors from '../../styles/colors';
import consts from '../../utils/consts';

// interfaces
interface ContainerOptionsInterface {
    marginTop?: string,
    maxWidth?: string,
    positionItemHorizontal?: string,
    positionItemVertical?: string,
    wrap?: string,
    width?: string,
}

interface ContainerAdjustIconEditInterface {
    right?: string,
}

interface TitleOptionInterface {
    width?: string,
}

// styles
export const CloseModal = styled.button`
    align-items: center;
    background-color: ${colors.basic.white};
    border-radius: 25px;
    border-width: 0px;
    cursor: pointer;
    height: 50px;
    justify-items: center;
    width: 50px;
`;

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
`;

export const ContainerAdjustIconEdit = styled.div<ContainerAdjustIconEditInterface>`
    align-items: center;
    background-color: ${colors.theme.smoke};
    border-radius: 15px;
    bottom: 7px;
    display: flex;
    height: 30px;
    justify-content: center;
    opacity: 0.7;
    position: absolute;
    right: ${(props) => (props.right || '8px')};
    width: 30px;
`;

export const ContainerBox = styled.div`
    align-items: center;
    background-color: ${colors.basic.white};
    border-radius: 5px;
    box-shadow: 1px 1px 3px gray;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 80px;
    max-height: calc(100vh - 210px);
    width: 80%;
    max-width: 1000px;
    overflow-y: auto;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 30px;
`;

export const ContainerMore = styled.div`
    align-items: center;
    background-color: ${colors.basic.white};
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    width: 33%;
`;

export const ContainerOptions = styled.div<ContainerOptionsInterface>`
    align-items: ${(props) => (props.positionItemVertical || 'center')};
    background-color: ${colors.basic.white};
    display: flex;
    flex-wrap: ${(props) => (props.wrap || 'nowrap')};
    justify-content: ${(props) => (props.positionItemHorizontal || 'space-between')};
    margin-top: ${(props) => (props.marginTop || '0px')};
    width: ${(props) => (props.width || 'auto')};
    max-width: ${(props) => (props.maxWidth || 'none')};
`;

export const InfoOption = styled.h1`
    color: ${colors.basic.black};
    font-size: 14px;
    font-weight: ${consts.getFontWeight('Lato-Light')};
    width: 33%;
    word-wrap: break-word;
`;

export const InputNullSelectedPhoto = styled.input`
    align-items: center;
    cursor: pointer;
    height: 112px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 200px;
`;

export const LineSeparator = styled.div`
    background-color: ${colors.basic.gray};
    height: 1px;
    margin-top: 20px;
    opacity: 0.3;
    width: 100%;
`;

export const Logo = styled.img`
    height: 100px;
    width: 100px;
`;

export const TitleBox = styled.h1`
    color: ${colors.basic.black};
    font-size: 22px;
    font-weight: ${consts.getFontWeight('Lato-Bold')};
    margin-top: 20px;
`;

export const Title = styled.h1`
    color: ${colors.basic.gray};
    font-size: 50px;
    font-weight: ${consts.getFontWeight('Lato-Bold')};
    padding-bottom: 30px;
`;

export const TitleOption = styled.h1<TitleOptionInterface>`
    color: ${colors.basic.black};
    font-size: 17px;
    font-weight: ${consts.getFontWeight('Lato-Regular')};
    width: ${(props) => (props.width || '33%')};
`;
